module.exports = __webpack_public_path__ + "/static/assets/a3e689235188ba10c5cfd75730cb88a7.svg";